export const getMinAndMaxPlaceholders = (value: number, options: ReadonlyArray<number>): string => {
  if (value === options[0]) return 'Min';
  if (value === options[options.length - 1]) return 'Max';
  return value.toString();
};
